import { useAuthentication } from '@auth/hooks/useAuthentication'
import { IMkAuthorizedSession } from '@auth/types'

/**
 * Returns the first membership's level label from /me (e.g. "VIP DIAMOND").
 * The backend applies brand+contractType aware mapping to turn the raw tier description
 * (e.g. "VIP BY WORLDMARK DIAMOND") into a clean display label.
 *
 * TODO: the points-benefits API response should include this label so the page
 *       does not need a separate /me call. Move resolution to the backend endpoint
 *       and remove this hook once that change is in place.
 */
export function useMeLevelLabel(): string | null {
  const { isAuthorized, session } = useAuthentication()

  if (!isAuthorized) return null

  return (session as IMkAuthorizedSession | undefined)?.authorizedUser?.tier ?? null
}
